import { Link } from "react-router-dom";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import Reveal from "@/components/feature/Reveal";
import Seo from "@/components/feature/Seo";
import SiteFooter from "@/components/feature/SiteFooter";
import SiteHeader from "@/components/feature/SiteHeader";
import useHashScroll from "@/hooks/useHashScroll";
import { getArticlesByCategory } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function TopicsPage() {
  useHashScroll();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Seo
        title="主题档案 - 按方向浏览事件解读 | 15黑料网"
        description="15黑料网主题档案按娱乐观察、商业风云、网络热点、社会话题与科技前沿五个方向归档全部事件解读，方便按兴趣成批浏览。"
        keywords="事件分类,主题档案,事件解读分类,15黑料网"
        canonicalPath="/topics"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "主题档案",
            url: "https://sznita.cn/topics",
            description: "按方向归档的全部事件解读主题。",
            inLanguage: "zh-CN",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://sznita.cn/" },
              { "@type": "ListItem", position: 2, name: "主题档案", item: "https://sznita.cn/topics" },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "ItemList",
            itemListElement: categories.map((cat, index) => ({
              "@type": "ListItem",
              position: index + 1,
              name: cat.name,
              url: `https://sznita.cn/topic/${cat.slug}`,
            })),
          },
        ]}
      />
      <SiteHeader />
      <main className="w-full flex-1">
        <section className="w-full border-b border-background-200 bg-background-100/60">
          <div className="mx-auto w-full max-w-[1400px] px-4 pb-10 pt-8 md:px-8 md:pb-12 md:pt-10">
            <Breadcrumbs items={[{ label: "主题档案" }]} />
            <h1 className="mt-5 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              主题档案
            </h1>
            <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
              不同领域的事件，往往共享同一套结构。我们把解读按方向归档，方便你横向对照：同样是「合作破裂」，
              在文娱行业和商业世界里，触发点和代价有什么不同。
            </p>
          </div>
        </section>

        <section aria-label="主题列表" className="w-full bg-background-50">
          <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-8 md:py-14">
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
              {categories.map((cat, index) => {
                const count = getArticlesByCategory(cat.slug).length;
                return (
                  <Reveal key={cat.slug} delay={index * 60}>
                    <Link
                      to={`/topic/${cat.slug}`}
                      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 sm:flex-row cursor-pointer"
                    >
                      <div className="h-44 w-full shrink-0 overflow-hidden bg-background-100 sm:h-auto sm:w-56">
                        <img
                          src={cat.cover}
                          alt={`${cat.name}主题档案配图`}
                          title={`${cat.name} - 15黑料网事件解读`}
                          className="h-full w-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
                        />
                      </div>
                      <div className="flex flex-1 flex-col p-6">
                        <p className="label-caps text-[10px] text-secondary-500">
                          {cat.english}
                        </p>
                        <h2 className="mt-2.5 font-heading text-xl font-black text-foreground-950 transition-colors group-hover:text-primary-700">
                          {cat.name}
                        </h2>
                        <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                          {cat.description}
                        </p>
                        <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                          <span className="text-xs text-foreground-500">
                            收录 {count} 篇解读
                          </span>
                          <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                            进入专题
                            <i
                              className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"
                              aria-hidden="true"
                            />
                          </span>
                        </div>
                      </div>
                    </Link>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}